import { getCoreRowModel, useReactTable, flexRender } from '@tanstack/react-table';
import React from 'react'
import { FaEdit, FaTimes } from 'react-icons/fa';

const CheckpointsTable = ({
    checkpoints,
    onDelete,
    onEdit
}) => {
    const columns = React.useMemo(
        () => [
            {
                header: 'Site',
                accessorKey: 'site.name'
            },
            {
                header: 'Name',
                accessorKey: 'name'
            },
            {
                header: 'Latitude',
                accessorKey: 'latitude'
            },
            {
                header: 'Longitude',
                accessorKey: 'longitude'
            },
            {
                header: 'Geofence Radius(m)',
                accessorKey: 'geo_fence_radius'
            },
            {
                header: 'RFID Serial #',
                accessorKey: 'rfid_tag_id'
            },
            {
                header: 'Created By',
                accessorKey: 'user.name'
            },
            {
                header: 'Date Created',
                accessorKey: 'created_at'
            },
            {
                header: 'Date Updated',
                accessorKey: 'updated_at'
            },
            {
                header: 'Actions',
                id: 'actions',
                cell: ({row}) => (
                    <>
                        <FaTimes 
                            className='fa-times'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={() => onDelete(row.original.id)}
                            title='Delete'
                        />
                        <FaEdit
                            className='fa-edit'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={() => onEdit(row.original.id)}
                            title='Edit'
                        />
                    </>
                )
            }
        ],
        [onEdit, onDelete]
    );

    const table = useReactTable({
        data: checkpoints,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (checkpoints.length === 0){
        return <div className="text-center">No site locations found</div>
    }
  return (
    <table className='table table-striped'>
        <thead>
        {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
                <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
            ))}
            </tr>
        ))}
        </thead>
        <tbody>
        {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
            ))}
            </tr>
        ))}
        </tbody>
    </table>
  )
}

export default CheckpointsTable